// extracted by mini-css-extract-plugin
export default {"container":"Book_container__1apbK","containerInfo":"Book_containerInfo__9TTKN","image":"Book_image__eZ0pY","title":"Book_title__hKDfs","footerInfo":"Book_footerInfo__Qgu-e"};